import type { LegalPersonKind, LoanAgreementStatus, LoanItemOutcome } from "@/contracts";

import type { Tone } from "@/components/ui/badge";
import i18n from "@/i18n";

/**
 * Wording for the loan screens.
 *
 * "Signed" is the label that matters: it reads as though the platform
 * witnessed something, so every place it appears is paired with a sentence
 * saying a member of staff recorded a paper signature. See ADR-074.
 */
export const LOAN_STATUS_LABELS: Record<LoanAgreementStatus, string> = {
  get DRAFT() {
    return i18n.t("loans:status.DRAFT");
  },
  get ISSUED() {
    return i18n.t("loans:status.ISSUED");
  },
  get SIGNED() {
    return i18n.t("loans:status.SIGNED");
  },
  get CLOSED() {
    return i18n.t("loans:status.CLOSED");
  },
  get CANCELLED() {
    return i18n.t("loans:status.CANCELLED");
  },
};

export const LOAN_STATUS_TONES: Record<LoanAgreementStatus, Tone> = {
  DRAFT: "neutral",
  ISSUED: "info",
  // Signed is the state where equipment is out under agreed terms, which is
  // the one worth reading as healthy.
  SIGNED: "ok",
  CLOSED: "neutral",
  CANCELLED: "neutral",
};

export const LOAN_OUTCOME_LABELS: Record<LoanItemOutcome, string> = {
  get RETURNED() {
    return i18n.t("loans:outcome.RETURNED");
  },
  get RETURNED_DAMAGED() {
    return i18n.t("loans:outcome.RETURNED_DAMAGED");
  },
  get LOST() {
    return i18n.t("loans:outcome.LOST");
  },
  get CONTINUED() {
    return i18n.t("loans:outcome.CONTINUED");
  },
};

export const LEGAL_PERSON_LABELS: Record<LegalPersonKind, string> = {
  get HUMAN() {
    return i18n.t("loans:borrowerKind.HUMAN");
  },
  get LEGAL_ENTITY() {
    return i18n.t("loans:borrowerKind.LEGAL_ENTITY");
  },
};
